/**************************************************
 * Nombre:       Formulario_Mesa_Config
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid} from "@mui/material";
import IngresoTexto from "../../Modulo_formularios/Componentes/IngresoTexto";
import {FlagOutlined, Flag, GroupOutlined, TableRestaurantOutlined,ZoomInMapOutlined} from "@mui/icons-material";
import IngresoSelect from "../../Modulo_formularios/Componentes/IngresoSelect";
import {ESTADOSMESASCONFIG} from "../../Constantes";
import {useEffect, useState} from "react";
import {obtenerCol} from "../../Servicios/BD/obtenerCol";

const Formulario_Mesa_Config = ({...props}) => {
    const [sectores, setSectores] = useState([]);


    useEffect(() => {
        obtenerCol('sectores').then((dox) => {
            if (dox.res) {
                setSectores(dox.data);
            }
        })
    }, []);
    return (
        <form noValidate style={{width: '100%'}}>
            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                spacing={2}
            >


                <Grid container size={{xs: 6, sm: 6, md: 6}}>
                    <IngresoSelect Icono={Flag} nombre={'Estado'} dato={'estado'} {...props}
                                   requerido={'El estado es requerido'}
                                   opciones={ESTADOSMESASCONFIG.map((it) => it.nombre)}
                    />
                </Grid>

                <Grid container size={6}/>

                <Grid container size={6}>
                    <IngresoSelect Icono={ZoomInMapOutlined} nombre={'Sector'} dato={'sector'} {...props}
                        opciones={sectores.map((it) => it.nombre)}                    />
                </Grid>

                <Grid container size={6}>
                    <IngresoTexto Icono={FlagOutlined} nombre={'Tipo'} dato={'tipo'} {...props}
                    />
                </Grid>

                <Grid container size={6}>
                    <IngresoTexto Icono={TableRestaurantOutlined} nombre={'Nombre'} dato={'nombre'} {...props}
                                  requerido={'Campo requerido'}
                    />
                </Grid>

                <Grid container size={6}>
                    <IngresoTexto Icono={GroupOutlined} nombre={'Num Personas Maximo'} dato={'numPersonas'} {...props}
                                  requerido={'Campo requerido'} type={'number'}
                    />
                </Grid>


                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <IngresoTexto lineas={4} nombre={'Notas internas'} dato={'notas'} {...props}
                    />
                </Grid>


            </Grid>

        </form>

    )

}
export default Formulario_Mesa_Config